import { AnyAction } from "redux";
import { EventEntryInput } from "../states/event-management";
import { EventManagementActions } from "../../actions";

export interface IEventManagementState {
  events?: EventEntryInput[];
  eventDeletionStatus: "Requested" | "Success" | "Failed" | undefined;
  eventCreationStatus: "Requested" | "Success" | "Failed" | undefined;
}

export const initialEventManagementState: IEventManagementState = {
  events: [],
  eventDeletionStatus: undefined,
  eventCreationStatus: undefined,
};

function eventManagementReducer(state = initialEventManagementState, action: AnyAction): IEventManagementState {
  switch (action.type) {
    case EventManagementActions.CREATE_EVENT:
      return {
        ...state,
        eventCreationStatus: "Requested",
      };
    case EventManagementActions.CREATE_EVENT_SUCCESS:
      return {
        ...state,
        eventCreationStatus: "Success",
      };
    case EventManagementActions.CREATE_EVENT_FAILURE:
      return {
        ...state,
        eventCreationStatus: "Failed",
      };
    case EventManagementActions.CREATE_EVENT_FAILURE_ACKNOWLEDGED:
      return {
        ...state,
        eventCreationStatus: undefined,
      };
    case EventManagementActions.DELETE_EVENT:
      return {
        ...state,
        eventDeletionStatus: "Requested",
      };
    case EventManagementActions.DELETE_EVENT_SUCCESS:
      return {
        ...state,
        events: state.events?.filter((event) => {
          return event.id !== action.payload.id;
        }),
        eventDeletionStatus: "Success",
      };
    case EventManagementActions.DELETE_EVENT_FAILURE:
      return {
        ...state,
        eventDeletionStatus: "Failed",
      };
    case EventManagementActions.DELETE_EVENT_FAILURE_ACKNOWLEDGED:
      return {
        ...state,
        eventDeletionStatus: undefined,
      };
    case EventManagementActions.GET_EVENTS:
      return state;
    case EventManagementActions.GET_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.payload.data,
      };
    case EventManagementActions.GET_EVENTS_FAILURE:      
    case EventManagementActions.GET_EVENT:      
    case EventManagementActions.GET_EVENT_SUCCESS:
    case EventManagementActions.GET_EVENT_FAILURE:    
    case EventManagementActions.UPDATE_EVENT:
    case EventManagementActions.UPDATE_EVENT_SUCCESS:
    case EventManagementActions.UPDATE_EVENT_FAILURE:
    default:
      return state;
  }
}

export default eventManagementReducer;